var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-4 pa-sm-8",attrs:{"fluid":""}},[_c('v-data-table',{staticClass:"elevation-1 mt-10",attrs:{"mobile-breakpoint":0,"headers":_vm.headers,"items":_vm.payments,"loading":_vm.loading},scopedSlots:_vm._u([{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("moment")(new Date(parseInt(item.createdAt)),"MMM DD YYYY"))+" ")]}},{key:"item.price",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.numberWithCommas(item.price))+" ")]}},{key:"item.additionalMeals",fn:function(ref){
var item = ref.item;
return [_c('AdditionalMeals',{attrs:{"additionalMeals":item.additionalMeals}})]}},{key:"item.discount",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.numberWithCommas(item.discount))+" ")]}},{key:"item.netPrice",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.numberWithCommas(item.netPrice))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }